export default __webpack_public_path__ + "media/images/front/about/about_page_03_sm-0306e8d5ea0112efb41159359891aa87.jpg";